export function adminModerationSearch(search: Record<string, unknown>) {
  return {
    q: typeof search.q === "string" ? search.q : "",
    action: typeof search.action === "string" ? search.action : "all",
    target: typeof search.target === "string" ? search.target : "all",
    sort: search.sort === "oldest" ? "oldest" : "newest",
    page:
      Number.isSafeInteger(Number(search.page)) && Number(search.page) > 0
        ? Number(search.page)
        : 1,
    size: [10, 25, 50].includes(Number(search.size)) ? Number(search.size) : 10,
  };
}
